import { AxiosRequestConfig } from 'axios';

import { okrApi } from '~src/services/ApiController';
import { AsyncAction } from '~src/services/apiMiddleware';
import { getUrlFromObject } from '~src/utils';

import {
  clearObjectiveActionHack,
  deleteObjectiveActions,
  deleteSubobjectiveActions,
  getObjectiveActions,
  getObjectivesAT,
  getSubobjectivesActions,
  postObjectiveActions,
  postSubobjectiveActions,
  updateObjectiveActions,
} from './actionTypes';
import { ObjectiveItemUpdate, ObjectivesQueryI, ObjectivesResp, PostObjectiveApiBody } from './interfaces';

export const fetchObjectivesA = (
  queryObj?: ObjectivesQueryI,
  config?: AxiosRequestConfig,
): AsyncAction<ObjectivesResp> => {
  const query = getUrlFromObject({...queryObj});

  return {
    types: getObjectivesAT,
    callAPI: () => okrApi.get(`objectives${query}`, config),
    // callAPI: () => baseApi.get(`mocks/objectives${query}`),
  };
};

export const getSubobjectives = (superobjectiveId: string | null): AsyncAction<ObjectivesResp> => ({
  types: getSubobjectivesActions,
  callAPI: () => okrApi.get(`objectives/${superobjectiveId}?include=sub_objectives`),
  payload: { superobjectiveId },
});

export const deleteSubobjective = (superobjectiveId: string, subobjectiveId: string): AsyncAction<any> => ({
  types: deleteSubobjectiveActions,
  callAPI: () => okrApi.delete(`objectives/${superobjectiveId}/relations/sub_objectives/${subobjectiveId}`),
  payload: { superobjectiveId, subobjectiveId },
});

export const postSubobjective = (
  superobjectiveId: string,
  subobjectiveId: string,
  weighting: number | null,
): AsyncAction<any> => ({
  types: postSubobjectiveActions,
  callAPI: () =>
    okrApi.post(`objectives/${superobjectiveId}/relations/sub_objectives/${subobjectiveId}`, {
      sub_objective_weighting: weighting,
    }),
  payload: { superobjectiveId, subobjectiveId },
});

export const postObjective = (objective: PostObjectiveApiBody) => ({
  types: postObjectiveActions,
  callAPI: () => okrApi.post('objectives', objective),
});

export const getObjective = (id: string, config?: AxiosRequestConfig) => ({
  types: getObjectiveActions,
  callAPI: () => okrApi.get(`objectives/${id}`, config),
});

export const clearObjective = (id: string) => ({
  type: clearObjectiveActionHack,
  superobjectiveId: id,
});

export const updateObjective = (id: string, objective: ObjectiveItemUpdate) => ({
  types: updateObjectiveActions,
  callAPI: () => okrApi.put(`objectives/${id}`, objective),
});

export const deleteObjective = (objectiveId: string) => ({
  types: deleteObjectiveActions,
  callAPI: () => okrApi.delete(`objectives/${objectiveId}`),
  payload: { objectiveId },
});

export const getFeedbackObjectives = (
  args: { userId: string },
  queryObj?: ObjectivesQueryI,
  config?: AxiosRequestConfig,
) => {
  const query = getUrlFromObject(queryObj);

  return {
    callAPI: () => okrApi.get(`user/${args.userId}/objectives${query}?`, config)
  };
}
